<template>
    <div>
        <div class="header">
            <span class="fs30 medium">Utils</span>
            <img src="/img/logo.svg" alt="" />
        </div>

    </div>
</template>

<script>
    export default {
        name: 'Utils',
        data() {
          return {
            key: '',
          };
        },
    };
</script>

<style>
</style>
